import axios from '../../utils/axios';
import apiRequest from './apiRequest';

const buildSuccessStoryListQuery = ({
  page, limit, searchValue, clusterId, published, sort,
}) => {
  const params = new URLSearchParams({ page, limit, searchValue });
  if (clusterId) params.set('clusterId', clusterId);
  if (published !== undefined && published !== '') params.set('published', published);
  if (sort) params.set('sort', sort);
  return params.toString();
};

const getSuccessStories = ({
  page, limit, searchValue, clusterId, published, sort,
}) => apiRequest(() => axios.get(`/api/success-story?${buildSuccessStoryListQuery({
  page, limit, searchValue, clusterId, published, sort,
})}`));

const getSuccessStory = ({ id }) => apiRequest(() => axios.get(`/api/success-story/${id}`));

const postSuccessStoryCreate = ({ successStory }) => apiRequest(
  () => axios.post('/api/success-story/create', successStory),
);

const putSuccessStoryEdit = ({ id, successStory }) => apiRequest(
  () => axios.put(`/api/success-story/${id}`, successStory),
);

const postSuccessStoryPublish = ({ successStories }) => apiRequest(
  () => axios.post('/api/success-story/publish', successStories),
);

export default {
  getSuccessStories,
  getSuccessStory,
  postSuccessStoryCreate,
  putSuccessStoryEdit,
  postSuccessStoryPublish,
};
